export default function Tag({tag}) {
    return (
        <li className="tag">{tag}</li>
    );
}